export interface UniZenSwapResponse {
    data: string;
    contractVersion: string;
    estimateGas: string;
    estimateGasError: string;
    nativeValue: string;
    maxFeePerGas: string;
    maxPriorityFeePerGas: string;
    gasPrice: string;
}
